module.exports = __webpack_public_path__ + "static/media/curtin.6b4ec673.png";